"use strict";
/**
 * AngularJS tag box component controller.
 *
 * @packageDocumentation
 * @module TagBox
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#region Util Imports
var lodash_es_1 = require("lodash-es");
var jquery_1 = tslib_1.__importDefault(require("jquery"));
//#endregion
var base_1 = require("../../components/base");
var tag_box_interfaces_1 = require("./tag-box.interfaces");
var IMRTagBoxController = /** @class */ (function (_super) {
    tslib_1.__extends(IMRTagBoxController, _super);
    //#endregion
    //#region Ctor
    function IMRTagBoxController($element, $timeout) {
        var _this = _super.call(this) || this;
        _this.$element = $element;
        _this.$timeout = $timeout;
        _this.isOpened = false;
        //#endregion
        //#region DropDown Button
        _this.dropDownButtonOptions = null;
        //#endregion
        //#region Scroll View
        _this.scrollViewOption = null;
        _this.scrollView = null;
        //#endregion
        //#region Tag Box
        _this.tagBoxOptions = null;
        _this.tagBox = null;
        return _this;
    }
    Object.defineProperty(IMRTagBoxController.prototype, "isSaveOnBlur", {
        //#region Members
        get: function () {
            var _a;
            return (_a = this.options.saveOnBlur) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IMRTagBoxController.prototype, "isShowDropDownButton", {
        get: function () {
            var _a;
            return (_a = this.options.showDropDownButton) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IMRTagBoxController.prototype, "isShowScrollbar", {
        get: function () {
            var _a;
            return (_a = this.options.showScrollBar) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IMRTagBoxController.prototype, "dropDownButtonDirection", {
        get: function () {
            var _a;
            return ((_a = this.options.dropDownButtonDirection) !== null && _a !== void 0 ? _a : tag_box_interfaces_1.IMRTagBoxDropDownDirection.Up);
        },
        enumerable: true,
        configurable: true
    });
    //#endregion
    //#region Lifecycle
    IMRTagBoxController.prototype.initialize = function (options) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isOpened = false;
                        return [4 /*yield*/, this.initializeDropDownButton()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initializeScrollView()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.initializeTagBox()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.destroy = function () {
        var _a, _b;
        (_a = this.tagBox) === null || _a === void 0 ? void 0 : _a.dispose();
        (_b = this.scrollView) === null || _b === void 0 ? void 0 : _b.dispose();
    };
    //#endregion
    //#region IIMRTagBox Implementation
    IMRTagBoxController.prototype.getInnerTagBox = function () {
        return this.tagBox;
    };
    IMRTagBoxController.prototype.getSelectedItems = function () {
        if (this.tagBox != null) {
            return this.tagBox.option('selectedItems');
        }
        return [];
    };
    IMRTagBoxController.prototype.initializeDropDownButton = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isShowDropDownButton === true)) return [3 /*break*/, 2];
                        this.prepareDrowDownButtonOptions();
                        return [4 /*yield*/, this.waitForDropDownButtonInitialized()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.prepareDrowDownButtonOptions = function () {
        var _this = this;
        this.dropDownButtonOptions = {
            icon: this.dropDownButtonDirection === tag_box_interfaces_1.IMRTagBoxDropDownDirection.Down
                ? 'spindown'
                : 'spinup',
            onClick: function () {
                var _a;
                if (!_this.isOpened) {
                    (_a = _this.tagBox) === null || _a === void 0 ? void 0 : _a.open();
                }
            },
        };
    };
    IMRTagBoxController.prototype.waitForDropDownButtonInitialized = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.dropDownButtonOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.dropDownButtonOptions)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.initializeScrollView = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isShowScrollbar === true)) return [3 /*break*/, 2];
                        this.prepareScrollViewOptions();
                        return [4 /*yield*/, this.waitForScollViewInitialized()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.prepareScrollViewOptions = function () {
        this.scrollViewOption = {
            width: '100%',
            direction: 'horizontal',
            scrollByContent: true,
        };
    };
    IMRTagBoxController.prototype.waitForScollViewInitialized = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var scrollVieInitializedArgs;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.scrollViewOption != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.scrollViewOption)];
                    case 1:
                        scrollVieInitializedArgs = _b.sent();
                        this.scrollView = (_a = scrollVieInitializedArgs.component) !== null && _a !== void 0 ? _a : null;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.initializeTagBox = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.prepareTagBoxOptions();
                        return [4 /*yield*/, this.waitForTagBoxInitialized()];
                    case 1:
                        _a.sent();
                        this.registerTagBoxEvents();
                        return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.prepareTagBoxOptions = function () {
        var _a;
        this.tagBoxOptions = (_a = lodash_es_1.cloneDeep(this.options.innerOptions)) !== null && _a !== void 0 ? _a : {};
        this.tagBoxOptions.width = '100%';
        if (this.tagBoxOptions.multiline == null) {
            this.tagBoxOptions.multiline = false;
        }
    };
    IMRTagBoxController.prototype.waitForTagBoxInitialized = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tagBoxInnitializedArgs;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.tagBoxOptions != null)) return [3 /*break*/, 2];
                        return [4 /*yield*/, _super.prototype.waitForOnInitialized.call(this, this.tagBoxOptions)];
                    case 1:
                        tagBoxInnitializedArgs = _b.sent();
                        this.tagBox = (_a = tagBoxInnitializedArgs.component) !== null && _a !== void 0 ? _a : null;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    IMRTagBoxController.prototype.registerTagBoxEvents = function () {
        var _this = this;
        if (this.tagBox != null) {
            this.tagBox.on('closed', function (e) { return _this.onTagBoxClosed(e); });
            this.tagBox.on('keyDown', function (e) { return _this.onTagBoxKeyDown(e); });
            this.tagBox.on('focusOut', function (e) { return _this.onTagBoxFocusOut(e); });
            this.tagBox.on('opened', function (e) { return _this.onTagBoxOpened(e); });
        }
    };
    IMRTagBoxController.prototype.onTagBoxClosed = function (e) {
        this.isOpened = false;
    };
    IMRTagBoxController.prototype.onTagBoxFocusOut = function (e) {
        this.saveEditorValueOnBlur();
    };
    IMRTagBoxController.prototype.onTagBoxKeyDown = function (e) {
        this.saveEditorValueOnTabPress(e);
    };
    IMRTagBoxController.prototype.onTagBoxOpened = function (e) {
        this.isOpened = true;
        this.updateTagBoxPopoverWidth(e);
    };
    IMRTagBoxController.prototype.updateTagBoxPopoverWidth = function (e) {
        var _a;
        var $popoverOverlay = jquery_1.default('.dx-tagbox-popup-wrapper .dx-overlay-content.dx-popup-normal.dx-popup-draggable.dx-resizable');
        if ($popoverOverlay != null && this.scrollView != null) {
            var componentWidth_1 = (_a = this.$element.width()) !== null && _a !== void 0 ? _a : 0;
            var scrollLeft_1 = this.scrollView.scrollLeft();
            this.$timeout(function () {
                $popoverOverlay.width(componentWidth_1).css('left', scrollLeft_1);
            }, 0);
        }
    };
    IMRTagBoxController.prototype.saveEditorValueOnBlur = function () {
        if (this.isSaveOnBlur && this.tagBox != null) {
            if (this.saveOnBlurLastTypedValue !== '') {
                this.tagBox._createCustomItem(this.tagBox.option('text'));
                this.tagBox._completeSelection(this.tagBox.option('text'));
                this.saveOnBlurLastTypedValue = '';
            }
        }
    };
    IMRTagBoxController.prototype.saveEditorValueOnTabPress = function (e) {
        if (this.isSaveOnBlur && this.tagBox != null) {
            this.saveOnBlurLastTypedValue = this.tagBox.field().val();
            if (e.jQueryEvent.keyCode === 9) {
                if (this.saveOnBlurLastTypedValue !== '') {
                    this.tagBox._createCustomItem(this.tagBox.option('text'));
                    this.tagBox._completeSelection(this.tagBox.option('text'));
                    this.saveOnBlurLastTypedValue = '';
                }
            }
        }
    };
    return IMRTagBoxController;
}(base_1.IMRBaseComponentController));
exports.IMRTagBoxController = IMRTagBoxController;
//# sourceMappingURL=tag-box.controller.js.map